import { Banner } from '../bannerStore'
import july2026OfficeAutomation from './july_2026_office_automation'

export const allLocalBanners: Banner[] = [july2026OfficeAutomation]
